module.exports = __webpack_public_path__ + "static/media/logo-mini.ece3fe7d.svg";